import React, { createContext } from 'react';
import { IFlagsContext, IFlagsProvider } from './types';

export const FlagsContext = createContext<IFlagsContext>({});

export const FlagsProvider: React.FC<IFlagsProvider> = ({ children, flags }) => {
  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>;
};
